module.exports = __webpack_public_path__ + "img/22.32647ead.png";